var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-drawer',{attrs:{"width":"1080","title":"数据记录","visible":_vm.recordVisible},on:{"close":_vm.onClose}},[_c('deviceAcutal',{ref:"deviceAcutal"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }